module.exports = __webpack_public_path__ + "img/danger.1373a884.svg";